// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/icons/transcripts_calendar.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**** Transcripts page css ****/

/** The add/print stuff in the top right **/
#transcripts .additionalOptions {
  text-align: right;
  margin-left: auto; /* Make this aligned to the right */
}

/* Put a pipe character between the add / print buttons */
#transcripts .additionalOptions span {
  font-size: 20px;
}

#transcripts .additionalOptions span + span:before {
  content: '|';
  color: black;
  /* Typography for pipe between add and print actions */
  padding-left: 1rem;
  padding-right: 1.25rem;
}

#transcripts .datePickerHolder .datePickerHolderInner {
  margin-top: 1.75rem;
  padding-bottom: 1.75rem;
  border-bottom: 1px solid #e5e5e5;
}

#transcripts .datePickerHolderInner .selectText {
  width: 200px;
  margin-right: 0 !important;
}

#transcripts .datePickerHolderInner #divLmsDatetime {
  width: 160px !important;
}
/* Styling/layout for the separator text between the date pickers */
#transcripts .datePickerHolder .separatorText {
  font-size: 14px;
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  width: auto !important;
}

/* The error in case the start is greater than end date */
#dateRangeError {
  float: right;
  margin: 4px 0px;
  padding: 5px;
}

/** Transcripts table **/
/* Row formatting in the table.
 * This currently also formats header row.
 * Should be refactored
 */

/* table header formatting */
#transcripts .table thead th {
  padding-top: 2rem;
  padding-bottom: 2rem;
  font-size: 16px;
}

/* Format all the headers in the contents of each column */
#transcripts .table tr {
  border-bottom: 1px solid #e5e5e5;
}

/* Format all the headers in the contents of each column */
#transcripts .table tr td h3 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0.7rem;
  margin-top: 1rem;
}

/*
 * Make the left column (the title column) of the table line up with the page
 */
#transcripts .table .titleColumnHeader,
#transcripts .table .titleColumn {
  /* This column should take up the most space in the table */
  width: 42%;
}
/* format the contents of the left column (title column) */
#transcripts .table tr td p {
  font-size: 14px;
}

/*
 * Make the center column, the assignment type column, relatively small
 */
#transcripts .table .typeColumnHeader,
#transcripts .table .typeColumn {
  width: 17%;
}

#transcripts .table .codeColumnHeader,
#transcripts .table .codeColumn {
  width: 17%;
}

/*
 * Make sure the last column, the status column,
 * is generally near the right side of the page
 */
#transcripts .table .statusColumnHeader,
#transcripts .table .statusColumn {
  /* Giving this element an rem instead of a percentage
     * makes it easier to make it somewhat flush right */
  width: 27rem;
}
/* Format the contents of the status column */
#transcripts .table .statusColumn h3 {
  font-style: italic;
}
#transcripts .table .statusColumn a {
  font-size: 14px;
  color: black;
}

/**** Transcripts add modal specific styling ****/
/* Transcript add modal date picker */

.transcriptAddModal #divLmsDatetime {
  border: 1px solid black;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/* Show a custom calendar icon and position it over the original bootstrap calendar icon */

/* Make the original bootstrap calendar icon/button transparent */
.transcriptAddModal .datePicker .md-datepicker-calendar-icon {
  fill: rgba(0, 0, 0, 0);
}

/* Make it so we can position the .calendarIcon absolutely */
.transcriptAddModal .datePicker {
  position: relative;
}
/* Resize the transparent clickable button */
.transcriptAddModal .datePicker .md-button.md-icon-button {
  margin: 0;
}
/* Put the calendar icon over the original datepicker button */
.transcriptAddModal .datePicker .calendarIcon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 2rem;
  height: 2rem;
  background-size: contain;
  display: inline-block;
  position: absolute;
  top: 8px;
  left: 10px;
  z-index: 99999;
}

/* Make the triangle on the right hand side of the datepicker box larger */
.transcriptAddModal .datePicker .md-datepicker-expand-triangle {
  top: 65%;
  left: 16%;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 9px solid #b6b6b6;
}

/* Make the datepicker box close to the calendar icon */
.transcriptAddModal .datePicker .md-datepicker-input-container {
  margin-left: 0;
  background-color: white;
}

/* Get the two calendar pickers side by side */
#transcriptAddModal .startDateGroup,
#transcriptAddModal .completionDateGroup,
#peopleTabBatchAddTranscriptModal .startDateGroup,
#peopleTabBatchAddTranscriptModal .completionDateGroup {
  display: inline-block;
}

#batchAddTranscript {
  padding-left: 15px;
}

.ta .batch-resultsList {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Normally this is supposed to be prefixed with
 * #transcriptsAddModal however the transcripts calendar
 * is placed outside of the modal element since
 * it's dynamically created by bootstrap. */
#transcripts ~ div.md-datepicker-calendar-pane {
  z-index: 10000;
}

/**** View Certificate modal ****/
/* This part formats the area right around the image of
 * the certificate in the modal body */
#certificateModal .certInfo {
  float: none;
  margin: 15px auto;
  width: 806px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/users/transcripts.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B,2CAA2C;AAC3C;EACE,iBAAiB;EACjB,iBAAiB,EAAE,mCAAmC;AACxD;;AAEA,yDAAyD;AACzD;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sDAAsD;EACtD,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;AACA,mEAAmE;AACnE;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,yDAAyD;AACzD;EACE,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA,wBAAwB;AACxB;;;EAGE;;AAEF,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA,0DAA0D;AAC1D;EACE,gCAAgC;AAClC;;AAEA,0DAA0D;AAC1D;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE;AACF;;EAEE,2DAA2D;EAC3D,UAAU;AACZ;AACA,0DAA0D;AAC1D;EACE,eAAe;AACjB;;AAEA;;EAEE;AACF;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;EAGE;AACF;;EAEE;wDACsD;EACtD,YAAY;AACd;AACA,6CAA6C;AAC7C;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,iDAAiD;AACjD,qCAAqC;;AAErC;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,0FAA0F;;AAE1F,iEAAiE;AACjE;EACE,sBAAsB;AACxB;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;AACpB;AACA,4CAA4C;AAC5C;EACE,SAAS;AACX;AACA,8DAA8D;AAC9D;EACE,mDAAqE;EACrE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA,uDAAuD;AACvD;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA,8CAA8C;AAC9C;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;;2CAG2C;AAC3C;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;sCACsC;AACtC;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd","sourcesContent":["/**** Transcripts page css ****/\n\n/** The add/print stuff in the top right **/\n#transcripts .additionalOptions {\n  text-align: right;\n  margin-left: auto; /* Make this aligned to the right */\n}\n\n/* Put a pipe character between the add / print buttons */\n#transcripts .additionalOptions span {\n  font-size: 20px;\n}\n\n#transcripts .additionalOptions span + span:before {\n  content: '|';\n  color: black;\n  /* Typography for pipe between add and print actions */\n  padding-left: 1rem;\n  padding-right: 1.25rem;\n}\n\n#transcripts .datePickerHolder .datePickerHolderInner {\n  margin-top: 1.75rem;\n  padding-bottom: 1.75rem;\n  border-bottom: 1px solid #e5e5e5;\n}\n\n#transcripts .datePickerHolderInner .selectText {\n  width: 200px;\n  margin-right: 0 !important;\n}\n\n#transcripts .datePickerHolderInner #divLmsDatetime {\n  width: 160px !important;\n}\n/* Styling/layout for the separator text between the date pickers */\n#transcripts .datePickerHolder .separatorText {\n  font-size: 14px;\n  font-weight: bold;\n  margin-left: 10px;\n  margin-right: 10px;\n  width: auto !important;\n}\n\n/* The error in case the start is greater than end date */\n#dateRangeError {\n  float: right;\n  margin: 4px 0px;\n  padding: 5px;\n}\n\n/** Transcripts table **/\n/* Row formatting in the table.\n * This currently also formats header row.\n * Should be refactored\n */\n\n/* table header formatting */\n#transcripts .table thead th {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n  font-size: 16px;\n}\n\n/* Format all the headers in the contents of each column */\n#transcripts .table tr {\n  border-bottom: 1px solid #e5e5e5;\n}\n\n/* Format all the headers in the contents of each column */\n#transcripts .table tr td h3 {\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 0.7rem;\n  margin-top: 1rem;\n}\n\n/*\n * Make the left column (the title column) of the table line up with the page\n */\n#transcripts .table .titleColumnHeader,\n#transcripts .table .titleColumn {\n  /* This column should take up the most space in the table */\n  width: 42%;\n}\n/* format the contents of the left column (title column) */\n#transcripts .table tr td p {\n  font-size: 14px;\n}\n\n/*\n * Make the center column, the assignment type column, relatively small\n */\n#transcripts .table .typeColumnHeader,\n#transcripts .table .typeColumn {\n  width: 17%;\n}\n\n#transcripts .table .codeColumnHeader,\n#transcripts .table .codeColumn {\n  width: 17%;\n}\n\n/*\n * Make sure the last column, the status column,\n * is generally near the right side of the page\n */\n#transcripts .table .statusColumnHeader,\n#transcripts .table .statusColumn {\n  /* Giving this element an rem instead of a percentage\n     * makes it easier to make it somewhat flush right */\n  width: 27rem;\n}\n/* Format the contents of the status column */\n#transcripts .table .statusColumn h3 {\n  font-style: italic;\n}\n#transcripts .table .statusColumn a {\n  font-size: 14px;\n  color: black;\n}\n\n/**** Transcripts add modal specific styling ****/\n/* Transcript add modal date picker */\n\n.transcriptAddModal #divLmsDatetime {\n  border: 1px solid black;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n/* Show a custom calendar icon and position it over the original bootstrap calendar icon */\n\n/* Make the original bootstrap calendar icon/button transparent */\n.transcriptAddModal .datePicker .md-datepicker-calendar-icon {\n  fill: rgba(0, 0, 0, 0);\n}\n\n/* Make it so we can position the .calendarIcon absolutely */\n.transcriptAddModal .datePicker {\n  position: relative;\n}\n/* Resize the transparent clickable button */\n.transcriptAddModal .datePicker .md-button.md-icon-button {\n  margin: 0;\n}\n/* Put the calendar icon over the original datepicker button */\n.transcriptAddModal .datePicker .calendarIcon {\n  background: url('../../assets/images/icons/transcripts_calendar.svg');\n  width: 2rem;\n  height: 2rem;\n  background-size: contain;\n  display: inline-block;\n  position: absolute;\n  top: 8px;\n  left: 10px;\n  z-index: 99999;\n}\n\n/* Make the triangle on the right hand side of the datepicker box larger */\n.transcriptAddModal .datePicker .md-datepicker-expand-triangle {\n  top: 65%;\n  left: 16%;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-top: 9px solid #b6b6b6;\n}\n\n/* Make the datepicker box close to the calendar icon */\n.transcriptAddModal .datePicker .md-datepicker-input-container {\n  margin-left: 0;\n  background-color: white;\n}\n\n/* Get the two calendar pickers side by side */\n#transcriptAddModal .startDateGroup,\n#transcriptAddModal .completionDateGroup,\n#peopleTabBatchAddTranscriptModal .startDateGroup,\n#peopleTabBatchAddTranscriptModal .completionDateGroup {\n  display: inline-block;\n}\n\n#batchAddTranscript {\n  padding-left: 15px;\n}\n\n.ta .batch-resultsList {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* Normally this is supposed to be prefixed with\n * #transcriptsAddModal however the transcripts calendar\n * is placed outside of the modal element since\n * it's dynamically created by bootstrap. */\n#transcripts ~ div.md-datepicker-calendar-pane {\n  z-index: 10000;\n}\n\n/**** View Certificate modal ****/\n/* This part formats the area right around the image of\n * the certificate in the modal body */\n#certificateModal .certInfo {\n  float: none;\n  margin: 15px auto;\n  width: 806px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
